import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal, stagger, fadeUp } from "@/lib/motion";
import { TESTIMONIALS } from "@/lib/site-data";

const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32"
    >
      <Reveal className="max-w-2xl">
        <span className="eyebrow">Client stories</span>
        <h2 className="mt-5 font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
          Loved by the businesses we build for
        </h2>
      </Reveal>

      <motion.div
        variants={stagger(0.1)}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3"
      >
        {TESTIMONIALS.map((t) => (
          <motion.figure
            key={t.name}
            variants={fadeUp}
            data-testid={`testimonial-card-${t.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="group relative flex flex-col rounded-3xl border border-white/10 bg-ink-soft p-8 transition-colors duration-300 hover:border-white/20"
          >
            <Quote className="h-8 w-8 text-neon-cyan/30" />
            <div className="mt-4 flex items-center gap-1">
              {[...Array(t.rating)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-neon-cyan text-neon-cyan" />
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-base leading-relaxed text-white/75">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-7 flex items-center gap-3 border-t border-white/10 pt-6">
              <img
                src={t.image}
                alt={t.name}
                loading="lazy"
                className="h-11 w-11 rounded-full object-cover ring-2 ring-white/10"
              />
              <div>
                <p className="font-heading text-sm font-semibold text-white">{t.name}</p>
                <p className="text-xs text-white/50">{t.company}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </motion.div>
    </section>
  );
};

export default Testimonials;
